import React, { useRef, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled, ThemeProvider } from '@mui/material/styles';
import CustomModalAdicionarItem from '../customModalAdicionarItem/CustomModalAdicionarItem';
import { ItemPedido } from '../../dto/ItemPedido';
import TextField from '@mui/material/TextField';
import { ItemPrecoService } from '../../services/ItemPrecoService';
import { IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { formatNumber, formatNumbervalue } from '../../helpers/FormatValue';
import { labelGrid } from '../utils';
import { temaTabela } from '../theme/themeTable';

function CustomTableItems(props: { data: any; handleSetItemPedido: any; isPedido: boolean; search: boolean, editavel?: boolean, handleDeleteItem?: any; ordemDigitacao?: number, temTabPreco?: boolean }) {
  const [rows, setRows] = React.useState<any[]>([]);
  const [details, setDetails] = React.useState<any | null>(null);
  const [modalIndex, setModalIndex] = React.useState<number | null>(null);
  const [filter, setFilter] = React.useState<string>('');
  const [itemPrices, setItemPrices] = React.useState<Record<number, string>>({});
  const [haveItensPrice, setHaveItensPrice] = React.useState<boolean>(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const itemPrecoService = new ItemPrecoService();

  const showTableItems = ['codItem', 'descricao', 'qtd', 'unidade', 'valor', 'total', 'percIpi', 'valorIpi'];

  const toNumberSafe = (v: any): number => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const formatNumberSafe = (v: any) => formatNumber(toNumberSafe(v));
  const formatNumberValueSafe = (v: any) => formatNumbervalue(toNumberSafe(v));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#e9f2fd',
      color: '#0f3550',
      fontSize: '12px',
      letterSpacing: '0.6px',
      padding: '4px 16px',
      borderBottom: '2px solid #d9e5ee',
      position: 'sticky',
      top: 0,
      zIndex: 2,
      whiteSpace: 'nowrap',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '12px',
      color: '#334155',
      padding: '5px 16px',
      borderBottom: '1px solid #E2E8F0',
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    height: '32px',
    '&:nth-of-type(odd)': {
      backgroundColor: '#f8fafc',
    },
    '&:hover': {
      backgroundColor: '#eef4fb',
      transition: 'background-color 0.15s ease',
    },
    '&:last-child td, &:last-child th': {
      borderBottom: 0,
    },
  }));

  useEffect(() => {
    if (props.search && inputRef.current) {
      inputRef.current.focus();
    }
  }, [props.search]);

  React.useEffect(() => {
    if (props.data) {
      setRows(Array.isArray(props.data) ? props.data : []);
    }
  }, [props.data]);

  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(event.target.value);
  };

  const filteredRows = rows.filter((row: any) => {
    return showTableItems.some((key) => {
      const value = row[key];
      return value && String(value).toLowerCase().includes(filter.toLowerCase());
    });
  });

  const openDetails = (index: number) => {
    setDetails(rows[index]);
    setModalIndex(index);
  };

  const handleSetItemPedido = (item: ItemPedido) => {
    props.handleSetItemPedido(item);
  };

  const handleDeleteItem = (item: ItemPedido) => {
    props.handleDeleteItem(item);
  };

  return (
    <div>
      {props.search && (
        <TextField
          label="Filtrar"
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          fullWidth
          value={filter}
          autoFocus
          inputRef={inputRef} // agora funciona
          onChange={handleFilterChange}
          sx={{
            marginBottom: 2,
            '& .MuiOutlinedInput-root': {
              height: 36,
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 14px',
            },
          }}
        />
      )}

      <TableContainer
        component={Paper}
        sx={{
          flex: 1,
          overflow: 'auto',
          boxShadow: 'none',
          borderRadius: '4px',
          border: '1px solid #e2e8f0',
          minHeight: 300,
          maxHeight: 400,
        }}
      >
        <ThemeProvider theme={temaTabela}>
          <Table aria-label="sticky table" size='small'>
            <TableHead>
              <TableRow>
                {showTableItems.includes('codItem') && <StyledTableCell align="left" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.cod}</StyledTableCell>}
                {showTableItems.includes('descricao') && <StyledTableCell align="left" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.descricao}</StyledTableCell>}
                {showTableItems.includes('qtd') && props.isPedido && <StyledTableCell align="center" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.quantidade}</StyledTableCell>}
                {showTableItems.includes('unidade') && <StyledTableCell align="center" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.unidade}</StyledTableCell>}
                {showTableItems.includes('valor') && <StyledTableCell align="right" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.valor}</StyledTableCell>}
                {showTableItems.includes('percIpi') && <StyledTableCell align="right" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.percIpi}</StyledTableCell>}
                {showTableItems.includes('valorIpi') && <StyledTableCell align="right" sx={{ whiteSpace: 'nowrap', fontWeight: "bold" }}>{labelGrid.valorIpi}</StyledTableCell>}
                {showTableItems.includes('total') && props.isPedido && <StyledTableCell align="right" sx={{ fontWeight: "bold" }}>{labelGrid.total}</StyledTableCell>}
                <StyledTableCell align="center" sx={{ fontWeight: "bold" }}>{props.isPedido ? labelGrid.excluir : labelGrid.adicionar}</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row: any, index: number) => (
                <StyledTableRow key={index}>
                  {showTableItems.includes('codItem') && <TableCell align="left">{row.codItem}</TableCell>}
                  {showTableItems.includes('descricao') && <TableCell align="left">{row.descricao}</TableCell>}
                  {showTableItems.includes('qtd') && props.isPedido && <TableCell align="center">{row.qtd}</TableCell>}
                  {showTableItems.includes('unidade') && (
                    <TableCell align="center">
                      {row.codUnidade || row.unidade || '-'}
                    </TableCell>
                  )}
                  {!props.isPedido && showTableItems.includes('valor') && (
                    <TableCell align="right">
                      {formatNumberValueSafe(Number(row.preco ?? row.valor ?? 0))}
                    </TableCell>
                  )}
                  {props.isPedido && showTableItems.includes('valor') && (
                    <TableCell align="right">
                      {(() => {
                        const value = Number(row.itemPreco?.preco ?? row.valorTabela ?? row.valor ?? 0);
                        return formatNumberValueSafe(value);
                      })()}
                    </TableCell>
                  )}
                  {showTableItems.includes('percIpi') && <TableCell align="right">{row.percIpi ?? 0}</TableCell>}
                  {!props.isPedido && showTableItems.includes('percIpi') && (
                    <TableCell align="right">
                      {formatNumberValueSafe(Number(row.percIpi ?? 0) * (Number(row.valor ?? 0) / 100))}
                    </TableCell>
                  )}
                  {props.isPedido && showTableItems.includes('valorIpi') && (
                    <TableCell align="right">
                      {formatNumberValueSafe(Number(((row.valor / 100) * row.percIpi) * row.qtd))}
                    </TableCell>
                  )}
                  {showTableItems.includes('total') && props.isPedido && (
                    <TableCell align="right" >
                      {formatNumberValueSafe(Number(row.total ?? 0))}
                    </TableCell>
                  )}
                  <TableCell align="center">
                    {!props.isPedido && (
                      <CustomModalAdicionarItem
                        data={row}
                        openDetails={() => openDetails(index)}
                        index={index}
                        handleSetItem={handleSetItemPedido}
                        ordemDigitacao={props.ordemDigitacao}
                        temTabPreco={props.temTabPreco}
                        filtroRef={inputRef}
                      />
                    )}
                    {props.isPedido &&
                      <IconButton
                        aria-label="delete"
                        sx={{ color: '#e03131', width: 30, height: 30 }}
                        onClick={() => handleDeleteItem(row)}
                        disabled={!props.editavel}
                      >
                        <DeleteIcon sx={{ fontSize: 18 }} />
                      </IconButton>}
                  </TableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </ThemeProvider>
      </TableContainer>
    </div>
  );
}

export default CustomTableItems;
